import { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';

import TalkToExpertForm from '_components/composed/forms/TalkToExpertForm';

const StyledOuterContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: ${theme.colors.white};
`;

const StyledInnerContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: ${theme.spaces.large19X}px;

  position: relative;
  overflow: hidden;

  max-width: ${theme.spaces.large30X * 10}px;
  width: 100%;

  padding-top: ${theme.spaces.regular}px;
  padding-bottom: ${theme.spaces.regular}px;

  @media ${theme.devices.tablet} {
    flex-direction: column-reverse;
    gap: ${theme.spaces.large6X + 2}px;
    padding-left: ${theme.spaces.regular}px;
    padding-right: ${theme.spaces.regular}px;
    padding-top: ${theme.spaces.regular}px;
    padding-bottom: ${theme.spaces.large8X}px;
  }
`;

const StyledContentBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-top: ${theme.spaces.large19X}px;
  padding-bottom: ${theme.spaces.large15X}px;
  padding-left: ${theme.spaces.regular}px;
  padding-right: ${theme.spaces.regular}px;
  border: 1px solid ${theme.colors.indigo.light};
  background: ${`linear-gradient(0deg, ${theme.colors.indigo.light}, 30%, ${theme.colors.indigo.primary})`};

  @media ${theme.devices.tablet} {
    padding-top: ${theme.spaces.large9X}px;
    padding-bottom: ${theme.spaces.large5X}px;
    border-radius: 10px;
  }
`;

// eslint-disable-next-line prettier/prettier, react/display-name
const StyledTitle = styled(forwardRef(({ desktop, mobile, ...props }, ref) => <div ref={ref} {...props} />))`
  margin-bottom: ${theme.spaces.large}px;
  font-family: 'Inter';
  font-size: ${theme.fontSizes.large13X}px;
  font-weight: 600;
  line-height: 61.6px;
  letter-spacing: -0.03em;
  text-align: center;
  color: ${theme.colors.white};

  ${({ mobile }) =>
    mobile &&
    css`
      display: none;
    `}

  @media ${theme.devices.tablet} {
    font-size: ${theme.fontSizes.large8X}px;
    line-height: 39.6px;

    ${({ desktop }) =>
      desktop &&
      css`
        display: none;
      `}

    ${({ mobile }) =>
      mobile &&
      css`
        display: block;
      `}
  }
`;

const TalkToExpertSection = () => {
  return (
    <StyledOuterContainer>
      <StyledInnerContainer>
        <StyledContentBox>
          <StyledTitle desktop>
            See how we can help
            <br />
            your business
          </StyledTitle>
          <StyledTitle mobile>See how we can help your business</StyledTitle>
          <TalkToExpertForm onSubmit={() => {}} />
        </StyledContentBox>
      </StyledInnerContainer>
    </StyledOuterContainer>
  );
};

export default TalkToExpertSection;
